<template>
	<div
		ref="el"
		role="presentation"
		class="c-search-spinner"
		:class="el && 'c-search-spinner--ready'"
	>
		<div
			v-for="item in items"
			:key="item.id"
			class="c-search-spinner__item"
			:class="{
				'bg-white': item.color === 'white',
				'bg-blue': item.color === 'blue',
				'bg-purple': item.color === 'purple',
				'bg-red': item.color === 'red',
				'bg-orange': item.color === 'orange',
				'bg-green': item.color === 'green',
				'bg-cyan': item.color === 'cyan',
			}"
			:style="{
				'--move-percentage': `${item.movePercentage}%`,
				'--duration': `${item.duration}ms`,
				width: `${item.widthPercent}%`,
			}"
		></div>
	</div>
</template>

<script setup>
const el = ref(null);
const items = ref([]);

let idCounter = 1000;
const colors = ['white', 'blue', 'purple', 'red', 'orange', 'green', 'cyan'];
items.value.length = 0;
for (let i = 0; i < 8; i++) {
	const widthPercent = Math.random() * 0.29 + 0.01;
	items.value.push({
		id: idCounter++,
		movePercentage: Math.ceil(100 / widthPercent) / 100,
		widthPercent: Math.round(widthPercent * 100),
		duration: 1500 + Math.round(Math.random() * 1500),
		color: colors[Math.floor(Math.random() * colors.length)],
	});
}
</script>

<style lang="postcss">
.c-search-spinner {
	@apply relative flex w-full h-[5px] opacity-0 transition-opacity duration-1000 overflow-hidden;

	& > * {
		@apply flex-shrink-0 flex-grow-0;
	}
}
[aria-busy='true'] .c-search-spinner {
	@apply opacity-100 duration-100;
}

.c-search-spinner__item {
	@apply absolute left-[0px] top-[0px] h-full;
	animation: c-search-spinner__item var(--duration, 500ms) linear infinite;
}

@keyframes c-search-spinner__item {
	0% {
		transform: translateX(-100%);
	}
	100% {
		transform: translateX(calc(100 * var(--move-percentage, 1%)));
	}
}
</style>
